import { render } from "./release.vue?vue&type=template&id=f59f0622&scoped=true&ts=true"
import script from "./release.vue?vue&type=script&lang=ts"
export * from "./release.vue?vue&type=script&lang=ts"

import "./release.vue?vue&type=style&index=0&id=f59f0622&lang=less&scoped=true"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f59f0622"]])

export default __exports__